import omit from "lodash/omit";
import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const masterDataDistrictListService = (
  params: Types.MasterDataDistrictListRequest
) =>
  RestAPIClient.call<Types.MasterDataDistrictListResponse>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.List}/${String(params?.provinceId)}`,
    config: {
      requireAuthentication: true,
      params: omit(params, ["provinceId"]),
    },
  });

export const masterDataDistrictListShortService = (
  params: Types.MasterDataDistrictListRequest
) =>
  RestAPIClient.call<Types.MasterDataDistrictListShortResponse>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.List}/${String(params?.provinceId)}/short`,
    config: {
      requireAuthentication: true,
      params: omit(params, ["provinceId"]),
      byPassError: true,
    },
  });
